import { createElement, useEffect, useState } from 'react';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { routes } from "../../constants";
import { useStore, useStoreActions } from "../../contexts";
import { useEventReporter } from "../../event-reporter/EventReporter";
import { selectors } from "../../store/state-selectors";
import AcceptInvitationPage from "../AcceptInvitationPage/AcceptInvitationPage";

// Create Custom Sentry Route component
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SentryRoute = Sentry.withSentryRouting(Route);
function Logout() {
  const {
    reset
  } = useStoreActions();
  const {
    sendEventToGtm
  } = useEventReporter();
  useEffect(() => {
    sendEventToGtm('logout', {});
    reset(true);
  }, []);
  return /*#__PURE__*/_jsx(Redirect, {
    to: routes.home
  });
}
export default function MainPages(props) {
  const {
    authorizedPages,
    unauthorizedPages,
    LoggedOutComponent
  } = props;
  const hasUserInfo = useStore(selectors.user.hasUserInfo);
  const isVendor = useStore(selectors.user.isVendor);
  const hasBusiness = useStore(selectors.user.hasBusiness);
  const location = useLocation();
  const teamInvites = useStore(selectors.teamInvites);
  const [showInvitationPage, setShowInvitationPage] = useState(teamInvites.length > 0 && !hasBusiness);
  const redirectToHome = () => showInvitationPage ? /*#__PURE__*/_jsx(Redirect, {
    to: {
      pathname: routes.acceptInvitation,
      search: location.search
    }
  }) : /*#__PURE__*/_jsx(Redirect, {
    to: {
      pathname: routes.home,
      search: location.search
    }
  });
  return /*#__PURE__*/_jsxs(Switch, {
    children: [unauthorizedPages.map(_ref => {
      let {
        url,
        component
      } = _ref;
      return /*#__PURE__*/_jsx(SentryRoute, {
        path: url,
        component: component
      }, url);
    }), showInvitationPage ? /*#__PURE__*/_jsx(SentryRoute, {
      path: routes.acceptInvitation,
      render: () => /*#__PURE__*/_jsx(AcceptInvitationPage, {
        setShowInvitationPage: setShowInvitationPage
      })
    }) : authorizedPages.filter(_ref2 => {
      let {
        vendorOnly
      } = _ref2;
      return !vendorOnly || isVendor;
    }).map(_ref3 => {
      let {
        url,
        component
      } = _ref3;
      return /*#__PURE__*/_jsx(SentryRoute, {
        path: url,
        render: props => {
          if (!hasUserInfo) {
            return /*#__PURE__*/_jsx(LoggedOutComponent, {});
          } else {
            return /*#__PURE__*/createElement(component, props);
          }
        }
      }, url);
    }), /*#__PURE__*/_jsx(SentryRoute, {
      path: routes.login,
      render: redirectToHome
    }), /*#__PURE__*/_jsx(SentryRoute, {
      path: routes.logout,
      component: Logout
    }), /*#__PURE__*/_jsx(SentryRoute, {
      render: redirectToHome
    })]
  });
}